export default class FilmPoster {
  constructor(id, title, /* markerImageURL, */ markerSetURL, videoURL, facebook = '', instagram = '', twitter = '', youtube = '', website = '') {
    this.id = id
    this.title = title
    /* this.image = markerImageURL */
    this.markerSet = markerSetURL
    this.video = videoURL
    this.data = {}
    this.element = null
    this.videoElement = null
    this.markerElement = null
    this.loadingElement = null
    this.facebook = facebook
    this.instagram = instagram
    this.twitter = twitter
    this.youtube = youtube
    this.website = website
  }
}